import React, { useCallback, useState } from "react";
import {
  Dialog,
  DialogActions,
  Tabs,
  Tab,
  Typography,
  TextField,
  Table,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import { makeStyles } from "@mui/styles";

import searchAddress from "../services/address_search";
import {
  DialogTitle,
  DialogContent,
  Body,
  Label,
  Button,
  colorLabel,
  border,
} from "./index";

import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

// const addressData = {
//   "id": 1,
//   "address": "서울 금천구 가산동 470-8 케이씨씨 웰츠밸리 902-1",
//   "name": "카고콜 사무실1",
//   "phone": "010-1111-1118",
// }
const addressTypeRoad = "road";
const addressTypeJibun = "jibun";

const useStyles = makeStyles(() => ({
  tab: {
    minWidth: 75,
    margin: "0 auto",
  },
  dialogContent: {
    width: 363,
    padding: 0,
  },
  tabs: {
    borderBottom: border,
  },
  tabPanel: {
    paddingTop: 28,
    paddingLeft: 28,
    paddingBottom: 21,
    paddingRight: 28,
  },
  tabContent: {
    fontSize: 11,
    color: colorLabel,
  },
  searchContainer: {
    marginTop: 12,
  },
  tableRoad: {
    marginTop: 20,
    "& td:first-child": {
      width: 30,
      padding: 0,
      color: colorLabel,
    },
    "& tr:last-child td": {
      border: 0,
    },
  },
  tableJibun: {
    marginTop: 20,
    "& tr:last-child td": {
      border: 0,
    },
  },
  addressBase: {
    width: 235,
  },
  buttonAddressSearch: {
    marginLeft: 12,
    marginTop: 0,
  },
  dialogActions: {
    justifyContent: "center",
  },
  buttonClose: {
    width: 155,
    height: 37,
  },
}));

const getType = (tabValue: number) =>
  tabValue === 0 ? addressTypeRoad : addressTypeJibun;

function TabPanel(props: any) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Typography>{children}</Typography>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

export default function AddressSearch(props: any) {
  const classes = useStyles();
  const { open, close, setAddress, setAddressBaseJibun } = props;
  const [tabValue, setTabValue] = useState<number>(0);
  const [addresses, setAddresses] = useState<any>([]);

  const navigate = useNavigate();
  const { register, watch } = useForm();

  const changeTab = (event: any, newValue: number) => {
    setTabValue(newValue);
    setAddresses([]);
  };

  const selectAddress = useCallback(
    (addressObj: any) => {
      setAddress(addressObj.roadAddress || addressObj.jibunAddress);
      setAddresses([]);
      const type = getType(tabValue);
      if (type === addressTypeRoad) {
        setAddressBaseJibun(addressObj.jibunAddress);
      }
      close(true);
    },
    [close, setAddress, setAddressBaseJibun, tabValue]
  );

  const search = useCallback(async () => {
    try {
      const data = watch();
      const query = data.query.trim();
      const addressType = getType(tabValue);

      if (query === "") return;
      if (
        query.length < 4 ||
        query[query.length - 1] < "0" ||
        query[query.length - 1] > "9"
      ) {
        if (addressType === addressTypeJibun) {
          alert("동(읍/면/리)과 번지 수를 입력해 주세요");
        } else {
          alert("도로명주소와 건물번호/건물명을 입력해 주세요");
        }
        return;
      }

      const response = await searchAddress(navigate, query, addressType);
      if (response.data.addresses !== null) {
        setAddresses(response.data.addresses);
      } else {
        setAddresses([]);
      }
    } catch (e: any) {
      if (e.response !== undefined) {
        return;
      }
    }
  }, [watch, tabValue, navigate]);

  const enterEvent = async (e: any) => {
    if (e.key === "Enter") {
      e.preventDefault(); // form submit (서버 전공) 막음
      e.stopPropagation(); // form submit event 막기
      await search();
    }
  };
  // @ts-ignore
  return (
    <Dialog
      disableEscapeKeyDown
      maxWidth="xs"
      aria-labelledby="confirmation-dialog-title"
      open={open}
      onClose={(e: any, reason: string) => {
        if (reason === "backdropClick") return;
        close();
      }}
    >
      <DialogTitle>주소 검색</DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <Tabs
          value={tabValue}
          onChange={changeTab}
          indicatorColor="primary"
          textColor="primary"
          className={classes.tabs}
        >
          <Tab className={classes.tab} label="도로명 주소" {...a11yProps(0)} />
          <Tab className={classes.tab} label="지번 주소" {...a11yProps(1)} />
        </Tabs>
        <TabPanel className={classes.tabPanel} value={tabValue} index={0}>
          <Body className={classes.tabContent}>
            찾으시려는 도로명주소+건물번호/건물명 혹은 지번주소+번지수/건물명을
            입력해 주세요.
            <br />
            ex) 수내로 2
          </Body>
          <div className={classes.searchContainer}>
            <TextField
              {...register("query")}
              defaultValue={""}
              className={classes.addressBase}
              variant={"standard"}
              id="query"
              autoFocus
              onKeyUp={(e) => enterEvent(e)}
            />
            <Button className={classes.buttonAddressSearch} onClick={search}>
              검색
            </Button>
          </div>
          {addresses.length > 0 && (
            <Table className={classes.tableRoad}>
              <TableBody>
                {addresses.map((a: any, i: number) => (
                  <TableRow
                    key={i}
                    hover
                    onClick={() => {
                      selectAddress(a);
                    }}
                  >
                    {a.roadAddress && (
                      <>
                        <TableCell>
                          <Label>
                            도로명
                            <br />
                            지번
                          </Label>
                        </TableCell>
                        <TableCell>
                          <Body>
                            {a.roadAddress}
                            <br />
                            {a.jibunAddress}
                          </Body>
                        </TableCell>
                      </>
                    )}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </TabPanel>
        <TabPanel className={classes.tabPanel} value={tabValue} index={1}>
          <Body className={classes.tabContent}>
            찾으시려는 동(읍/면/리)과 번지수를 정확하게 입력해 주세요.
            <br />
            ex) 수내동 50-1
          </Body>
          <div className={classes.searchContainer}>
            <TextField
              {...register("query")}
              defaultValue={""}
              className={classes.addressBase}
              id="query"
              variant={"standard"}
              autoFocus
              onKeyUp={(e) => enterEvent(e)}
            />

            <Button className={classes.buttonAddressSearch} onClick={search}>
              검색
            </Button>
          </div>
          {addresses.length > 0 && (
            <Table className={classes.tableJibun}>
              <TableBody>
                {addresses.map((a: any, i: number) => (
                  <TableRow
                    key={i}
                    hover
                    onClick={() => {
                      selectAddress(a);
                    }}
                  >
                    <TableCell>
                      <Body>{a.jibunAddress}</Body>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </TabPanel>
      </DialogContent>
      <DialogActions className={classes.dialogActions}>
        <Button
          className={classes.buttonClose}
          onClick={() => {
            setAddresses([]);
            close(false);
          }}
        >
          닫기
        </Button>
      </DialogActions>
    </Dialog>
  );
}
